import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'
import {useMemo} from 'react'

/** Names of the given products that have no active trade name left, so they can never be stocked (CY-259). */
export function useGetInactivePrescribedNames(prescribedNameIds: readonly (string | null | undefined)[]) {
  const ids = prescribedNameIds.filter((id): id is string => Boolean(id))
  const [prescribedNames] = useQuery(queries.products.getPrescribedNamesActiveTradeNames(ids))

  return useMemo(
    () => prescribedNames.filter(name => name.tradeNames.length === 0).map(name => name.name),
    [prescribedNames]
  )
}
